import { Component } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

export enum Decision {
  None = 'none',
  Back = 'back',
  Continue = 'continue',
}

@Component({
  selector: 'app-fishnet-batch-decision-modal',
  templateUrl: './fishnet-batch-decision-modal.component.html',
})
export class FishnetBatchDecisionModalComponent {
  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {}

  Decision = Decision;

  onCancel() {
    this.ref.close();
  }

  onAccept(decision?: Decision) {
    this.ref.close(decision);
  }
}
